import { isEmpty } from '../../constants/FormValidations';
import { PAYMENT_METHODS } from '../../constants/constants';
import { NumberOf } from '../../constants/numberUtils';

export const BANK_ENTRY_FORM = 'bankEntryForm';

export const RADIO_CHOICES = [
    { key: 'payment', value: 'Payment' },
    { key: 'receive', value: 'Receive' },
];

export const notSameAccount = (value, allValues) => {
    if (value && allValues.bankAccount && value.id === allValues.bankAccount.id) {
        return 'Against Account cannot be the same as Bank Account';
    }
    return undefined;
};

export const positiveNumber = (value) => {
    if (!isEmpty(value) && NumberOf(value) <= 0) {
        return 'Amount must be positive';
    }
    return undefined;
};

export const dtoToFormValues = dto => ({
    type: dto.type,
    entryDate: dto.entryDate,
    amount: dto.amount,
    memo: dto.memo,
    paymentMethod: dto.paymentMethod
        ? PAYMENT_METHODS.find(m => m.value === dto.paymentMethod) || null
        : null,
    bankAccount: dto.bankAccount ? { id: dto.bankAccount.key, value: dto.bankAccount.value } : null,
    againstAccount: dto.againstAccount ? { id: dto.againstAccount.key, value: dto.againstAccount.value } : null,
    bankName: dto.bankName,
    refNumber: dto.refNumber,
    date: dto.date,
    remarks: dto.remarks,
    journalId: dto.journalId ? { id: dto.journalId.key, name: dto.journalId.value } : null,
});

export const buildPayload = (formValues, subCompany, confirm, uuid = null) => ({
    ...formValues,
    uuid,
    subCompany,
    state: confirm ? 'posted' : 'draft',
    bankAccount: formValues.bankAccount
        ? { key: formValues.bankAccount.id, value: formValues.bankAccount.value }
        : null,
    againstAccount: formValues.againstAccount
        ? { key: formValues.againstAccount.id, value: formValues.againstAccount.value }
        : null,
    paymentMethod: formValues.paymentMethod ? formValues.paymentMethod.value : null,
    bankName: formValues.bankName,
    refNumber: formValues.refNumber,
    date: formValues.date,
    remarks: formValues.remarks,
    journalId: formValues.journalId
        ? { key: formValues.journalId.id, value: formValues.journalId.name }
        : null,
});

export const getAccountingMessage = (type, bankAccountName, againstAccountName) => {
    if (!bankAccountName || !againstAccountName) return null;

    if (type === 'payment') {
        return `Credit from ${bankAccountName} and Debit to ${againstAccountName}`;
    }

    if (type === 'receive') {
        return `Debit to ${bankAccountName} and Credit from ${againstAccountName}`;
    }

    return null;
};
